import { styled, Switch as MuiSwitch } from "@mui/material";
import { ChangeEvent, FC } from "react";

interface SwitchProps {
  label: string;
  width?: string | number;
  value: boolean;
  onChange: (value: boolean) => void;
}

const SwitchContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "width",
})<{ width?: string | number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: ${(props) => props?.width || "100%"};
`;

const Switch: FC<SwitchProps> = ({ label, value, onChange, width }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };
  return (
    <SwitchContainer width={width}>
      <span>{label}</span>
      <MuiSwitch checked={value} onChange={handleChange} size="small" />
    </SwitchContainer>
  );
};

export { Switch };
